import { ReactElement } from "react";
import useAttention from "../../useAttention";
import "./AttentionShortcutDot.scss";

interface IProps {
    unreadCount: number;

    /**
     * Today's badge, kept for anyone Just nu is not switched on for.
     */
    fallback: ReactElement | null;
}

/**
 * The marker on the "Notiser" shortcut in the responsive menu.
 *
 * A dot rather than the number it shows today. The number beside it in the band
 * counts what there is to do; two numbers on one screen meaning different things
 * is how people stop trusting either.
 */
function AttentionShortcutDot(props: IProps): ReactElement | null {
    const { unreadCount, fallback } = props;

    const { list } = useAttention();

    if (!list?.applicable) {
        return fallback;
    }

    if (unreadCount === 0) {
        return null;
    }

    return <span className="AttentionShortcutDot" role="presentation" />;
}

export default AttentionShortcutDot;
